// extracted by mini-css-extract-plugin
module.exports = {"DrivenSale":"DrivenSale_DrivenSale__1CuGj","OrderFrom":"DrivenSale_OrderFrom__1fDda","OrderName":"DrivenSale_OrderName__J8hmu","TotalPrice":"DrivenSale_TotalPrice__2IAHd"};